<template>
  <div>
    <div class="container">
      <div class="outer-container">
        <h2 class="header-font">
          Eligibility to attend this assessment
        </h2>
        <div class="grid">
          <div class="white-bg">
            <h3>
              Can develop optimization strategies that increase the company's
              search engine results rankings.
            </h3>
          </div>

          <div class="white-bg">
            <h3>
              Can research SEO keywords to use throughout the company's website
              and marketing materials.
            </h3>
          </div>
          <div class="white-bg">
            <h3>
              Able to set measurable goals that demonstrate improvement in
              marketing efforts and monitor daily performance metrics to
              understand SEO strategy performance.
            </h3>
          </div>
          <div class="white-bg">
            <h3>
              Can efficiently communicate with other marketing professionals to
              align goals.
            </h3>
          </div>
          <div class="white-bg">
            <h3>
              Collaboration ability with others within the marketing department
              to manage SEO strategy and write compelling and high-quality
              website content, including blog posts and page descriptions.
            </h3>
          </div>
          <div class="white-bg">
            <h3>
              Can update content and website links for maximum optimization and
              search engine rankings.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.header-font {
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b !important;
  text-align: center;
  letter-spacing: 0;
  padding-bottom: 40px;
}
.outer-container {
  padding: 0 25px;
  padding-top: 100px;
  padding-bottom: 90px;
}

.outer-container h4 {
  font-family: 'Open Sans';
  font-size: 24px;
  font-weight: 700;

  line-height: 32px;
  letter-spacing: -0.6px;
  color: #3c4663;

  padding-bottom: 50px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 49px;
}
.grid h3 {
  padding-top: 50px;
  padding-left: 40px;
  padding-right: 30px;
  font-family: 'Open Sans';
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 700;

  line-height: 30px;
  letter-spacing: 0px;
  color: white;
  padding-bottom: 48px;
}
.grid p {
  padding-left: 40px;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #84888b;
  padding-right: 25px;
}
.white-bg {
  background-color: #00a653;
  box-shadow: 0px 10px 30px #3c46630d;
  border-radius: 10px;
  min-height: 300px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .outer-container {
    padding: 0 20px;
    padding-top: 50px;
    padding-bottom: 45px;
  }
  .outer-container h2 {
    font-size: 16px;
    letter-spacing: 6.4px;
    line-height: 24px;
    padding-bottom: 30px;
  }
  .outer-container h4 {
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  .grid h3 {
    padding-bottom: 20px;
    padding-top: 30px;
    padding-left: 10px;
    padding-right: 0;
  }
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1350px !important;
  }
}
</style>
